<template>
  <div class="text-textColor h-1/2">
    <!-- Overlay background when the form is shown -->
    <transition name="fade">
      <div
        v-if="showAddDocument"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <!-- Main form container -->
        <form
          @submit.prevent="addDocument"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: auto"
        >
          <!-- Loader overlay when loading -->
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <!-- Error message display -->
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <!-- Success message display -->
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>

          <!-- Form header with close button -->
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-sm font-semibold">Add a New Document</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              alt="icon"
              @click="close()"
            />
          </div>

          <!-- Form content -->
          <div class="grid grid-cols-1 p-4 gap-5">
            <!-- Document Type Dropdown -->
            <div class="text-sm col-span-1">
              <label class="block pb-1">Document Type</label>
              <select
                @input="handleDocumentTypeChange"
                v-model="selectedDocumentType"
                class="p-2 bg-gray-200 rounded-full w-full"
                required
              >
                <option disabled value="">Select</option>
                <option
                  v-for="document of filterDocumentTypes(itemIndex)"
                  :key="document.DocumentTypeId"
                  :value="document.DocumentTypeId"
                >
                  {{ document.Name }}
                </option>
              </select>
            </div>

            <!-- Checkbox to allow entering data -->
            <div
              class="text-sm col-span-1 bg-gray-200 flex items-center p-2 rounded-md gap-2"
            >
              <label class="flex-shrink-0">Enter Data</label>
              <el-popover trigger="hover" width="250" placement="top-left"
                ><el-button
                  slot="reference"
                  class="el-icon-info"
                  type="text"
                ></el-button>
                <p>
                  If you do not have an actual file check this box to enter
                  textual data e.g NHIF
                </p></el-popover
              >
              <input
                v-model="enterData"
                type="checkbox"
                class="p-2 bg-gray-200 rounded-md"
              />
            </div>

            <!-- Input for entering data -->
            <div v-if="enterData" class="text-sm col-span-1">
              <label class="block pb-1"
                >Data Input (e.g. NHIF, NSSF numbers)<span
                  v-if="enterData"
                  class="text-red-700"
                  >*</span
                ></label
              >

              <input
                v-model="dataInput"
                type="text"
                class="p-2 bg-gray-200 rounded-md w-full"
                :required="enterData"
              />
            </div>

            <!-- File input for uploading document -->
            <div class="text-sm col-span-1" v-if="!enterData">
              <label class="block pb-1"
                >Upload Document
                <span v-if="!enterData" class="text-red-700">*</span></label
              >
              <input
                v-on:change="getFile"
                type="file"
                class="p-2 bg-gray-200 rounded-md w-full"
                :required="!enterData"
              />
            </div>
          </div>

          <!-- Form submission button -->
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-md px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import { viewSecuredAttachment } from "@/utils/secureAttachmentsViewer";
import createPdf from "@/utils/createPdf";
import { jsPDF } from "jspdf";
import { PDFDocument } from "pdf-lib";

export default {
  name: "AddBank",
  components: { Loader },
  props: [
    "showAddDocument",
    "close",
    "itemIndex",
    "reload",
    "getErrorMessage",
    "getSuccessMessage",
    "flushMessages",
    "activeTab",
  ],

  data() {
    return {
      number: "",
      info: {
        EmployeeId: "",
        DocumentTypeId: "",
        File: "",
        DocumentType: "",
      },
      documents: [],
      workDocuments: [],
      personalDocuments: [],
      loading: false,
      create_success: null,
      create_error: null,
      display: false,
      showStatus: false,
      documentTypes: [],
      myDocuments: [],
      enterData: false,
      dataInput: "",
      selectedDocumentType: "",
      avatarUrl: "",
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
      "getUser",
    ]),
  },
  created() {
    this.getDocumentTypes();
    this.getMyDocuments();
    const { ProfilePicture } = this.getUser;
    this.getProfilePicUrlurl(ProfilePicture);
  },
  watch: {
    showAddDocument(isTrue) {
      if (!isTrue) {
        this.loading = false;
      }
    },
  },
  methods: {
    filterDocumentTypes() {
      return this.documentTypes.filter(
        (doc) => doc.DocumentClassification === this.activeTab
      );
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },

    handleEditButtonClick(leave) {
      // Handle the button click for the edit button
      //console.log(leave);
      this.leaveTypeToEdit = {
        LeaveId: leave.Id,
        Name: leave.Name,
        Country: leave.Country,
        ...leave,
      };
      this.showEditLeaveType = true;
    },
    handleDeleteButtonClick(leaveType) {
      // Handle the button click for the delete button
      //console.log(leaveType);
      this.title = `Delete ${leaveType.Name}`;
      this.message = `You are about to delete ${leaveType.Name}!`;
      this.leaveTypeToDelete = leaveType;
      this.showWarning = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
    },

    handleDocumentTypeChange(event) {
      const selectedValue = event.target.value;
      this.info.DocumentTypeId = selectedValue;
    },

    getFile({ target }) {
      const file = target.files[0];
      this.info.File = file;
    },

    async addImageToPdf(pdfDoc, imageBytes) {
      // Embed the JPG image bytes and PNG image bytes

      let image;
      switch (this.info.File.type) {
        case "image/jpeg":
          image = await pdfDoc.embedJpg(imageBytes);
          break;
        case "image/png":
          image = await pdfDoc.embedJpg(imageBytes);
          break;
        case "image/jpg":
          image = await pdfDoc.embedJpg(imageBytes);
          break;
        default:
          this.$notify.error({
            title: "Error",
            message:
              "Invalid file type. Allowed files include .jpeg, .png and .jpg",
          });
          this.loading = false;
          break;
      }

      // Get the width/height of the JPG image scaled down to 25% of its original size
      const imageDims = image.scale(0.3);

      // Add a blank page to the document
      const page = pdfDoc.addPage();

      // Draw the JPG image in the center of the page
      page.drawImage(image, {
        x: page.getWidth() / 2 - imageDims.width / 2,
        y: page.getHeight() / 2 - imageDims.height / 2,
        width: imageDims.width,
        height: imageDims.height,
      });

      return page;
    },

    async createPdfWithImage(imageBytes, text, name) {
      const pdfDoc = await PDFDocument.create();
      await this.addImageToPdf(pdfDoc, imageBytes, name);
      return pdfDoc.save();
    },

    async addDocument() {
      this.info.EmployeeId = this.getCurrentEmployeeId;
      this.loading = true;
      const { Name } = this.filterDocumentTypes().find(
        (doc) => doc.DocumentTypeId === this.selectedDocumentType
      );

      const formData = new FormData();
      formData.append("EmployeeId", this.getCurrentEmployeeId);
      formData.append("DocumentTypeId", this.selectedDocumentType);

      if (this.enterData) {
        let text = `${Name}: ${this.dataInput}`;

        // Create PDF using jsPDF
        const pdfBytes = await createPdf(text);

        // Append the Blob directly to FormData
        formData.append(
          "File",
          new Blob([pdfBytes], { type: "application/pdf" }),
          `${Name}.pdf`
        );
      } else if (this.isImageFile(this.info.File)) {
        // Read the image file as a Uint8Array
        const imageBytes = await this.readFileAsUint8Array(this.info.File);

        // Create a new PDF with the attached image
        const pdfBytes = await this.createPdfWithImage(
          imageBytes,
          `${Name}:`,
          Name
        );

        formData.append(
          "File",
          new Blob([pdfBytes], { type: "application/pdf" }),
          `${Name}.pdf`
        );
      } else {
        formData.append("File", this.info.File, `${Name}.pdf`);
      }

      const options = {
        headers: {
          accept: "*/*",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      axios
        .post(
          `${this.getOrganization}/employee/document/${this.$ApiVersion}/upload`,
          formData,
          options
        )
        .then((response) => {
          // Handle success response
          if (response.data.StatusCode === 200) {
            this.reload();
            this.close();
            this.getSuccessMessage(response.data.StatusMessage);
            setTimeout(() => {
              this.flushMessages();
            }, 2000);
          } else {
            // Handle error response
            this.create_error = response.data.StatusMessage;
            this.getErrorMessage(response.data.StatusMessage);
            setTimeout(() => {
              this.flushMessages();
            }, 2000);
          }
        })
        .catch((error) => {
          // Handle error
          this.loading = false;
          this.create_error = error.message;
          this.getErrorMessage(error.message);
          setTimeout(() => {
            this.flushMessages();
          }, 2000);
        })
        .finally(() => {
          // Reset loading state
          this.loading = false;
        });
    },

    async readFileAsUint8Array(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          const result = event.target.result;
          const uint8Array = new Uint8Array(result);
          resolve(uint8Array);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsArrayBuffer(file);
      });
    },
    isImageFile(file) {
      // Check by MIME type
      const allowedMimeTypes = ["image/jpeg", "image/png", "image/gif"];
      if (allowedMimeTypes.includes(file.type)) {
        return true;
      }

      // Check by file extension
      const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif"];
      const fileName = file.name.toLowerCase();
      return allowedExtensions.some((ext) => fileName.endsWith(ext));
    },
    async createPdf(text) {
      const pdf = new jsPDF();
      pdf.text(text, 10, 10);

      // Create pdf
      const pdfBytes = pdf.output();

      return pdfBytes;
    },

    async getProfilePicUrlurl(url) {
      // console.log(url);
      const imageUrl = await viewSecuredAttachment(url, this.getToken);

      this.avatarUrl = imageUrl;
    },
    // /{organization}/setup/document/type/v1/request
    getDocumentTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .get(
          `${this.getOrganization}/setup/document/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.documentTypes = response.data.Data;
              this.personalDocuments = this.documentTypes.filter(
                (doc) => doc.DocumentClassification === "Personal"
              );

              this.workDocuments = this.documentTypes.filter(
                (doc) => doc.DocumentClassification === "Personal"
              );
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    // /{organization}/employee/{employeeId}/document/v1/request
    getMyDocuments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/document/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.myDocuments = response.data.Data;
              this.work = this.myDocuments.filter((doc) => doc.type == 0);
              this.personal = this.myDocuments.filter((doc) => doc.type == 1);
              //console.log(response.data.Data)
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
